import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Shield, Users, Wrench } from 'lucide-react';
export function AboutPage() {
  return <div className="bg-white" data-id="element-109">
      {/* Hero Section with Video Background */}
      <div className="relative bg-brand-dark text-white py-32 md:py-48 overflow-hidden" data-id="element-110">
        {/* Video Background */}
        <div className="absolute inset-0 z-0" data-id="element-111">
          <div className="absolute inset-0 bg-black/60 z-10" data-id="element-112"></div>
          <video autoPlay loop muted playsInline className="w-full h-full object-cover" data-id="element-113">
            <source src="https://www.websiteforge.net/custom/SpedUpLapse.mp4" type="video/mp4" data-id="element-114" />
          </video>
        </div>

        <div className="relative z-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-115">
          <h1 className="text-4xl md:text-6xl font-bold mb-8 tracking-tight" data-id="element-116">
            Built for Professionals
          </h1>
          <div className="max-w-3xl mx-auto space-y-6" data-id="element-117">
            <p className="text-xl md:text-2xl text-gray-200 font-medium leading-relaxed" data-id="element-118">
              We don't build toys. We build tools for contractors who depend on
              their gear to make a living.
            </p>
            <p className="text-lg text-gray-300 leading-relaxed" data-id="element-119">
              Precision Pro Sprayers was founded with a simple goal: eliminate
              the frustrations that slow contractors down. We saw professionals
              struggling with battery failures, heavy lifting, and messy
              chemical transfers.
            </p>
            <p className="text-lg text-gray-300 leading-relaxed" data-id="element-120">
              The ForceX product line is our answer. By focusing on corded
              electric power and siphon-based systems, we've removed the weak
              points of traditional sprayers. No batteries to die in the middle
              of a job. No tanks to carry on your back. Just reliable,
              continuous pressure.
            </p>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20" data-id="element-121">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20" data-id="element-122">
          <div className="text-center p-8 bg-brand-light rounded-xl border border-gray-100" data-id="element-123">
            <Shield className="h-12 w-12 text-brand-yellow mx-auto mb-4" data-id="element-124" />
            <h3 className="text-xl font-bold text-brand-dark mb-3" data-id="element-125">
              Reliability First
            </h3>
            <p className="text-gray-600" data-id="element-126">
              Equipment failure costs money. We design for simplicity and
              durability to keep you working.
            </p>
          </div>
          <div className="text-center p-8 bg-brand-light rounded-xl border border-gray-100" data-id="element-127">
            <Wrench className="h-12 w-12 text-brand-yellow mx-auto mb-4" data-id="element-128" />
            <h3 className="text-xl font-bold text-brand-dark mb-3" data-id="element-129">
              Contractor Focused
            </h3>
            <p className="text-gray-600" data-id="element-130">
              Every feature is designed around the real-world needs of
              remediation and maintenance pros.
            </p>
          </div>
          <div className="text-center p-8 bg-brand-light rounded-xl border border-gray-100" data-id="element-131">
            <Users className="h-12 w-12 text-brand-yellow mx-auto mb-4" data-id="element-132" />
            <h3 className="text-xl font-bold text-brand-dark mb-3" data-id="element-133">
              Efficiency
            </h3>
            <p className="text-gray-600" data-id="element-134">
              Time is money. Our systems set up fast, spray fast, and clean up
              fast.
            </p>
          </div>
        </div>

        <div className="text-center bg-brand-dark text-white rounded-2xl p-12" data-id="element-135">
          <h2 className="text-3xl font-bold mb-6" data-id="element-136">
            Ready to upgrade your equipment?
          </h2>
          <a href="/#kits" data-id="element-137">
            <Button variant="primary" size="lg" data-id="element-138">
              View The ForceX Lineup
            </Button>
          </a>
        </div>
      </div>
    </div>;
}